import {createFileRoute, redirect} from '@tanstack/react-router'

import {FOOD_SUPPORTED_COUNTRIES} from '@/lib/food-grubhub/config'
import {countryAtom} from '@/lib/locale/country'

export const Route = createFileRoute('/_food-grubhub')({
  component: Outlet,
  beforeLoad: ({context}) => {
    const currentCountry = context.store.get(countryAtom)
    if (!FOOD_SUPPORTED_COUNTRIES.includes(currentCountry)) {
      alert('Food & Delivery is only available in the US and Canada')
      throw redirect({
        to: '/',
      })
    }
  },
})
